import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './icsi2ndMonth.scss';

export default function ICSI2ndMonth1stScan(props) {
  const [showTables, setShowTables] = useState({
    medication: true,
    immuneTherapies: true,
    investigations: true,
    obstetricHistory: true
  });
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [otherComplaintSelected, setOtherComplaintSelected] = useState(false);

  const [obstetricHistoryRows, setObstetricHistoryRows] = useState([
    { outcome: '', modeOfConception: '', weeks: '', modeOfDelivery: '', babyOutcome: '', complications: '', comments: '' }
  ]);

  const obstetricHistoryHeaders = [
    { key: 'outcome', label: 'G Outcome', inputType: 'select', options: ['Term', 'Preterm', 'Miscarriage', 'Ectopic'] },
    { key: 'modeOfConception', label: 'Mode of Conception', inputType: 'select', options: ['Natural', 'IUI', 'IVF'] },
    { key: 'weeks', label: 'Weeks' },
    { key: 'modeOfDelivery', label: 'Mode of Delivery', inputType: 'select', options: ['Vaginal', 'LSCS', 'Medical', 'Surgical Miscarriage'] },
    { key: 'babyOutcome', label: 'Baby Outcome', inputType: 'select', options: ['Alive', 'Expired', 'Other'] },
    { key: 'complications', label: 'Complications', inputType: 'select', options: ['BP', 'DM', 'BT', 'ICU', 'Nil', 'Other'] },
    { key: 'comments', label: 'COMMENTS' }
  ];

  const [medicationRows, setMedicationRows] = useState([
    { sno: "1", drug: "Folvista / Cor 3 / MecobMB", genericName: "L-Methylfolate + Pyridoxine + Cyanocobalamin", dosage: "1 tab", freq: "0-0-1", relationToFood: "After food", duration: "30 days", purpose: "Hematinic + methylation support" },
    { sno: "2", drug: "Ecospirin", genericName: "Aspirin", dosage: "75 mg", freq: "0-1-0", relationToFood: "After food", duration: "30 days", purpose: "Improve uterine blood flow" },
    { sno: "3", drug: "Vomibune", genericName: "Doxylamine + Pyridoxine", dosage: "Max 2 tabs × TID", freq: "PRN", relationToFood: "Before food", duration: "SOS", purpose: "Anti-emetic" },
    { sno: "4", drug: "Evaraft", genericName: "Sodium Alginate + Sodium Bicarbonate + Calcium Carbonate", dosage: "10 mL", freq: "BD PRN", relationToFood: "After food", duration: "SOS", purpose: "Reflux relief" },
    { sno: "5", drug: "Progynova", genericName: "Estradiol Valerate", dosage: "2 mg", freq: "1-0-1", relationToFood: "After food", duration: "As advised", purpose: "Endometrial preparation" },
    { sno: "6", drug: "Dydrofic / Dydroboon/Dydroboon", genericName: "Dydrogesterone", dosage: "10 mg", freq: "1-1-1", relationToFood: "After food", duration: "30 days", purpose: "Luteal support" },
    { sno: "7", drug: "Inj. Aqgest", genericName: "Progesterone (aqueous)", dosage: "50 mg", freq: "1-0-0", relationToFood: "SC / IM (morning)", duration: "As advised", purpose: "Luteal support" },
    { sno: "8", drug: "Inj. Gestone", genericName: "Natural micronized progesterone hormone", dosage: "100 mg", freq: "1-0-0", relationToFood: "IM", duration: "As advised", purpose: "Luteal support" },
    { sno: "9", drug: "Gufigest / Gestobond", genericName: "Natural Micronised Progesterone", dosage: "400 mg", freq: "0-0-1 / BD", relationToFood: "Vaginal", duration: "As advised", purpose: "Luteal support" },
    { sno: "10", drug: "Evaparin /lonopin", genericName: "Enoxaparin", dosage: "0.4 / 0.6 mL", freq: "1-0-0 / Alternate days", relationToFood: "SC (morning)", duration: "As advised", purpose: "Anticoagulation (implantation support)" },
    { sno: "11", drug: "Glycomet SR", genericName: "Metformin", dosage: "500 mg", freq: "OD", relationToFood: "After food", duration: "Ongoing", purpose: "Insulin resistance control" },
    { sno: "12", drug: "Thyronorm", genericName: "Levothyroxine", dosage: "As advised", freq: "OD", relationToFood: "Empty stomach", duration: "Ongoing", purpose: "Thyroid optimization" },
    { sno: "13", drug: "HCQ", genericName: "Hydroxychloroquine", dosage: "200 mg", freq: "1-0-1", relationToFood: "After food", duration: "As advised", purpose: "Immunomodulation (↓ NK activity, ↓ inflammation)" },
    { sno: "14", drug: "Wysolone", genericName: "Prednisolone", dosage: "10 mg", freq: "1-0-0", relationToFood: "After food", duration: "As advised", purpose: "Immune suppression (↓ NK cells, ↓ Th1 response)" },
    { sno: "15", drug: "Vivamom (Sugar free)", genericName: "Maternal protein supplement", dosage: "2 tsp", freq: "OD/BD", relationToFood: "With milk", duration: "30 days", purpose: "Nutritional support" },
    { sno: "16", drug: "Vwash", genericName: "Intimate hygiene wash (lactic acid based)", dosage: "As advised", freq: "OD / BD", relationToFood: "External use", duration: "As advised", purpose: "Maintain vaginal hygiene" },
    { sno: "17", drug: "Influvac Tetra", genericName: "Quadrivalent Influenza Vaccine", dosage: "0.5 mL", freq: "Single dose", relationToFood: "IM", duration: "Once (seasonal)", purpose: "Prevent influenza infection in pregnancy" },
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S. No'},
    {key: 'drug', label: 'Drug Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dosage'},
    {key: 'freq', label: 'Frequency'},
    {key: 'relationToFood', label: 'Relation to Food / Route'},
    {key: 'duration', label: 'Duration'},
    {key: 'purpose', label: 'Purpose'}
  ];

  const [immuneRows, setImmuneRows] = useState([
    { sno: "1", drug: "Intralipid", genericName: "Lipid emulsion", route: "IV infusion", freq: "Weekly once", duration: "As advised", purpose: "↓ NK cell activity" },
    { sno: "2", drug: "Bharglobin", genericName: "IV Immunoglobulin (IVIG)", route: "IV infusion", freq: "Weekly once", duration: "As advised", purpose: "Immune modulation" },
    { sno: "3", drug: "Thymosin α1", genericName: "Thymosin alpha-1", route: "SC", freq: "As advised", duration: "As advised", purpose: "T-cell modulation" },
  ]);

  const immuneHeaders = [
    {key: 'sno', label: 'S.NO'},
    {key: 'drug', label: 'DRUG NAME'},
    {key: 'genericName', label: 'GENERIC NAME'},
    {key: 'route', label: 'ROUTE'},
    {key: 'freq', label: 'FREQUENCY'},
    {key: 'duration', label: 'DURATION'},
    {key: 'purpose', label: 'PURPOSE'}
  ];

  const investigationRows = [
    {name: 'Blood Group and Rh typing', value: ''},
    {name: 'Complete Blood Count (CBC)', value: ''},
    {name: 'TSH & Free T4', value: ''},
    {name: 'Urea, Creatinine', value: ''},
    {name: 'Random Blood Sugar / HbA1c / GCT (75g Glucose)', value: ''},
    {name: 'HIV, HBsAg, VDRL, Anti-HCV', value: ''},
    {name: 'Rubella IgG', value: ''},
    {name: 'Urine Routine and Culture', value: ''}
  ];

  const investigationHeaders = [{key: 'name', label: 'Investigation'}, {key: 'value', label: 'Result'}];

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('icsi2ndMonth1stScanReportWrap').innerHTML;
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'ICSI 2 nd month(1 st Scan)'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => { props.popupalert('false'); }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({ title: 'Error.', text: 'Please enter valid patient id.', icon: 'error', showConfirmButton: false, timer: 1500 });
      }
    } catch (error) { console.error('An error occurred:', error); }
  };

  return (
    <div id='ICSI2ndMonth1stScanTemplate'>
      <div className='ICSI2ndMonthTemplate'>
        <div style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>ICSI 2nd Month (1st Scan) - ASCAS</h2>
          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-4'><ReportFormInputWithLabel label='ET Date:' name='etDate' value={formData.etDate} onChange={handleChange} type='date' /></div>
            <div className='col-md-4'><ReportFormInputWithLabel label='POG:' name='pog' value={formData.pog} onChange={handleChange} endLabel='Weeks' /></div>
            <div className='col-md-4'><ReportFormInputWithLabel label='EDD:' name='edd' value={formData.edd} onChange={handleChange} type='date' /></div>
          </div>
          <div className='row'>
            <div className='col-md-4'><ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} onChange={handleChange} endLabel='mmHg' /></div>
            <div className='col-md-4'><ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} onChange={handleChange} endLabel='kg' /></div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Complaints'
                name='complaints'
                value={formData.complaints}
                options={[
                  {label: 'Nausea/Vomiting', value: 'Nausea/Vomiting'},
                  {label: 'Bleeding', value: 'Bleeding'},
                  {label: 'Others', value: 'Others'}
                ]}
                onChange={e => {
                  handleChange(e);
                  setOtherComplaintSelected(e.target.value === 'Others');
                }}
                placeholder='Select Complaint'
              />
            </div>
            {otherComplaintSelected && (
              <div className='col-md-4'>
                <ReportFormInputWithLabel label='Other:' name='otherComplaintDescription' value={formData.otherComplaintDescription} required={false} onChange={handleChange} />
              </div>
            )}
          </div>

          <h4 className='mt-3'>Obstetric History:</h4>
          <div className='row'>
            <div className='col-md-3'><ReportFormInputWithLabel label='G:' name='g' value={formData.g} onChange={handleChange} /></div>
            <div className='col-md-3'><ReportFormInputWithLabel label='P:' name='p' value={formData.p} onChange={handleChange} /></div>
            <div className='col-md-3'><ReportFormInputWithLabel label='L:' name='l' value={formData.l} onChange={handleChange} /></div>
            <div className='col-md-3'><ReportFormInputWithLabel label='A:' name='a' value={formData.a} onChange={handleChange} /></div>
            <div className='col-md-3'><ReportFormInputWithLabel label='E:' name='e' value={formData.e} onChange={handleChange} /></div>
          </div>
          <TemplateTable id='obstetricHistory' headers={obstetricHistoryHeaders} rows={obstetricHistoryRows} onRowsChange={(id, rows) => setObstetricHistoryRows(rows)} enableActions={true} />

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='scanFinding' className='fw-bold' style={{width: '180px'}}>🖥️ Scan Finding:</label>
            <textarea className='Textarea' placeholder='Scan Finding' id='scanFinding' name='scanFinding' onChange={handleChange} rows='5' cols='100' />
          </div>

          {showTables.medication && <TemplateTable id='medication' title='💊 Drug Chart' headers={medicationHeaders} rows={medicationRows} onRowsChange={(id, rows) => setMedicationRows(rows)} enableActions={true} />}
          
          {showTables.immuneTherapies && <TemplateTable id='immuneTherapies' title='🔷 ADD-ON IMMUNE / ADJUNCT THERAPIES' headers={immuneHeaders} rows={immuneRows} onRowsChange={(id, rows) => setImmuneRows(rows)} enableActions={true} />}
        </div>

        <div className='bulletin'>
          <h4>🚨 BLEEDING PROTOCOL</h4>
          <h5 className='fw-bold'>🔷 Medication</h5>
          <TemplateTable 
            id='bleedingMed' 
            headers={[{key:'drug', label:'Drug'}, {key:'generic', label:'Generic Name'}, {key:'dose', label:'Dose'}, {key:'freq', label:'Frequency'}, {key:'route', label:'Route'}, {key:'purpose', label:'Purpose'}]}
            rows={[{drug:'Trapic', generic:'Tranexamic acid', dose:'500 mg', freq:'2–3 times/day', route:'Oral', purpose:'Reduce bleeding'}]}
            enableActions={false}
          />
          <h5 className='fw-bold mt-3'>🔷 Instructions</h5>
          <ul className='ms-5 mt-3'>
            <li>Continue <b>Dydrofirst</b> (1-1-1) and <b>Aqgest / Gestone</b> (IM daily).</li>
            <li><b>Stop Gestobond / Gufigest</b> for 1 week.</li>
            <li><b>Stop Evaparin and Ecospirin</b> for 5 days.</li>
            <li>Avoid travel, intercourse, and exertion.</li>
            <li>If mild bleeding → visit ASCAS next day.</li>
            <li>If heavy bleeding → seek emergency care immediately.</li>
            <li><b>📞 +91-9342521779 / Contact your clinical coordinator immediately</b></li>
          </ul>
        </div>

        <div className='d-flex align-items-start py-2'>
          <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>ADVICE:</label>
          <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='3' cols='100'></textarea>
        </div>
        <p className='pt-3' style={{fontWeight: '600'}}>NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} /></p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}><button onClick={handlesubmit} className='Button_Create'>Add Report</button></div>
      </div>

      <div id='icsi2ndMonth1stScanReport'>
        <div id='icsi2ndMonth1stScanReportWrap'>
          <Headers />
          <h4 style={{textAlign: "center", fontWeight: 700, margin: "20px 0"}}>ICSI 2nd Month (1st Scan) - ANTENATAL SUMMARY</h4>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('ET Date:', formData.etDate?.split('-').reverse().join('-'))}
            {renderReportfield('POG:', `${formData.pog || ''} Weeks`)}
            {renderReportfield('EDD:', formData.edd?.split('-').reverse().join('-'))}
            {renderReportfield('BP:', `${formData.bp || ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight || ''} kg`)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Complaints:', formData.complaints)}
            {otherComplaintSelected && renderReportfield('Other:', formData.otherComplaintDescription)}
          </div>
          <div style={{fontWeight: 'bold'}}>Obstetric History: G{formData.g} P{formData.p} L{formData.l} A{formData.a} E{formData.e}</div>
          {renderDynamicTable('', ['G Outcome', 'Mode of Conception', 'Weeks', 'Mode of Delivery', 'Baby Outcome', 'Complications', 'COMMENTS'], ['outcome', 'modeOfConception', 'weeks', 'modeOfDelivery', 'babyOutcome', 'complications', 'comments'], obstetricHistoryRows)}
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('🖥️ Scan Finding:', formData.scanFinding)}</div>
          
          {renderDynamicTable('💊 Drug Chart', ['S. No', 'Drug Name', 'Generic Name', 'Dosage', 'Frequency', 'Relation to Food / Route', 'Duration', 'Purpose'], ['sno', 'drug', 'genericName', 'dosage', 'freq', 'relationToFood', 'duration', 'purpose'], medicationRows)}
          
          {renderDynamicTable('🔷 ADD-ON IMMUNE / ADJUNCT THERAPIES', ['S.NO', 'DRUG NAME', 'GENERIC NAME', 'ROUTE', 'FREQUENCY', 'DURATION', 'PURPOSE'], ['sno', 'drug', 'genericName', 'route', 'freq', 'duration', 'purpose'], immuneRows)}

          <div style={{marginTop: '15px'}}>
            <h6 style={{fontWeight: 600}}>🚨 BLEEDING PROTOCOL</h6>
            <h6 style={{fontWeight: 600, marginTop: '10px'}}>🔷 Medication</h6>
            {renderDynamicTable('', ['Drug', 'Generic Name', 'Dose', 'Frequency', 'Route', 'Purpose'], ['drug', 'generic', 'dose', 'freq', 'route', 'purpose'], [{drug:'Trapic', generic:'Tranexamic acid', dose:'500 mg', freq:'2–3 times/day', route:'Oral', purpose:'Reduce bleeding'}])}
            <h6 style={{fontWeight: 600, marginTop: '10px'}}>🔷 Instructions</h6>
            <ol style={{marginLeft: '30px', marginTop: '10px'}}>
              <li>Continue <b>Dydrofirst</b> (1-1-1) and <b>Aqgest / Gestone</b> (IM daily).</li>
              <li><b>Stop Gestobond / Gufigest</b> for 1 week.</li>
              <li><b>Stop Evaparin and Ecospirin</b> for 5 days.</li>
              <li>Avoid travel, intercourse, and exertion.</li>
              <li>If mild bleeding → visit ASCAS next day.</li>
              <li>If heavy bleeding → seek emergency care immediately.</li>
              <li>📞 +91-9342521779 / Contact your clinical coordinator immediately</li>
            </ol>
          </div>
          
          <div style={{marginBottom: '5px'}}><div style={{fontWeight: '600'}}>ADVICE:</div><pre style={{fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre></div>
          <div style={{marginTop: '20px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
